import { dicNames, i18n } from '../../../lang/i18n';
import HelperProducts from "../../../common/HelperProducts";
import dayjs from 'dayjs';
import { CustomerDeliveryOrderStatus, PaymentStatus } from "../../../common/Enums";
import { useAppSelector } from "../../../store/hooks";

function stateIcon(order: any, state: number)
{
    if (order.orderStatus.id >= state)
        return 'far fa-check-square';
    else
        return 'far fa-square';
}

function stateColor(colors:any, order: any, state: number)
{
    if (order.orderStatus.id >= state)
        return colors.priceColor;
    else
        return 'black';
}

export function RenderStatus(order: any, colors:any)
{
    if (order.paymentStatus.id !== PaymentStatus.PayOk) return null;
    if (order.orderStatus.id === CustomerDeliveryOrderStatus.Delivered) return null;
    return <div className="col-12 order-status">
        <div>
            <i className={stateIcon(order, CustomerDeliveryOrderStatus.Waiting)} style={{ color: stateColor(colors,order, CustomerDeliveryOrderStatus.Waiting) }} />
            <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerDeliveryOrderStatus.Waiting]}</div>
        </div>
        <div>
            <div style={{ marginTop: -10, marginLeft: 4, fontSize: 30, color: stateColor(colors,order, CustomerDeliveryOrderStatus.Waiting) }}>:</div>
            <div style={{ flex: 1 }}></div>
        </div>
        <div>
            <i className={stateIcon(order, CustomerDeliveryOrderStatus.OrderReady)} style={{ color: stateColor(colors,order, CustomerDeliveryOrderStatus.OrderReady) }} />
            <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerDeliveryOrderStatus.OrderReady]}</div>
        </div>
        <div>
            <div style={{ marginTop: -10, marginLeft: 4, fontSize: 30, color: stateColor(colors,order, CustomerDeliveryOrderStatus.OrderReady) }}>:</div>
            <div style={{ flex: 1 }}></div>
        </div>
        <div>
            <i className={stateIcon(order, CustomerDeliveryOrderStatus.InTransport)} style={{ color: stateColor(colors,order, CustomerDeliveryOrderStatus.InTransport) }} />
            <div style={{ flex: 1, paddingLeft: 10, fontSize: 14 }}>{dicNames[CustomerDeliveryOrderStatus.InTransport]}</div>
        </div>
        <div>
            <div style={{ marginTop: -10, marginLeft: 4, fontSize: 30, color: stateColor(colors,order, CustomerDeliveryOrderStatus.InTransport) }}>:</div>
            <div style={{ flex: 1 }}></div>
        </div>
        <div>
            <i className={stateIcon(order, CustomerDeliveryOrderStatus.InDelivery)} style={{ color: stateColor(colors,order, CustomerDeliveryOrderStatus.InDelivery) }} />
            <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerDeliveryOrderStatus.InDelivery]}</div>
        </div>
        <div>
            <div style={{ marginTop: -10, marginLeft: 4, fontSize: 30, color: stateColor(colors,order, CustomerDeliveryOrderStatus.Delivered) }}>:</div>
            <div style={{ flex: 1 }}></div>
        </div>
        <div>
            <i className={stateIcon(order, CustomerDeliveryOrderStatus.Delivered)} style={{ color: stateColor(colors,order, CustomerDeliveryOrderStatus.Delivered) }} />
            <div style={{ flex: 1, paddingLeft: 10 }}>{dicNames[CustomerDeliveryOrderStatus.Delivered]}</div>
        </div>
    </div>
}

interface Props
{
    order: any,
    onClose: () => void
}

export default function DeliverOrder(props: Props)
{
    const appConf = useAppSelector((state) => state.appConf)
    const productExtras = useAppSelector((state) => state.appData.productExtras)
    const order = props.order;

    return (<div className="users">

        <div className="container" style={{ border: '1px solid gainsboro', borderRadius: '5px', padding: '10px' }}>
            <div className="row">
                <div className="col-6">{i18n.DeliveryOrder.Order}: {props.order.orderCode}</div>
                <div className="col-6 text-center">{dayjs(order.orderDate).format("DD/MM/YYYY HH:mm")}</div>
            </div>
            <hr className="mt-4"></hr>
            <div className="row">
                <div className="col-1"></div>
                <div className="col-6">{i18n.CustomerInvoices.PRODUCT}</div>
            </div>
            {order.products.map((item: any, index: number) => (
                <div className="row" key={index}>
                    <div className="col-1">{item.quantity}</div>
                    <div className="col-7">{HelperProducts.ProductDescription(productExtras, item)}</div>
                    <div className="col-4">{(item.price * item.quantity).toFixed(2)}€</div>
                </div>
            ))}
            <div className="row">
                <div className="col-1"></div>
                <div className="col-7">{i18n._Labels.Transport}</div>
                <div className="col-4">{order.transport.price === 0 ? i18n._Labels.Free : order.transport.price.toFixed(2) + '€'}</div>
            </div>
            <hr className="mb-4" />
            <div className="row">
                <div className="col-4">{i18n.CustomerInvoices.PriceTotalNet}: {order.totalPriceNet.toFixed(2)}€</div>
                <div className="col-4">{i18n.CustomerInvoices.PriceTotalVat}: {order.totalPriceVat.toFixed(2)}€</div>
                <div className="col-4">{i18n.CustomerInvoices.PriceTotal}: {order.totalPrice.toFixed(2)}€</div>
            </div>
            <div className="row">
                <div className="col-md-6">{i18n.CustomerInvoices.RitmitosAccumulated}: {order.ritmitosLoyalty}⚡</div>
                <div className="col-md-6">{i18n.CustomerInvoices.RitmitosUsed}{order.ritmitosUsed}⚡</div>
            </div>
            <hr className="mb-4" />
            <div className="row">
                <div className="col-12 mt-3">{RenderStatus(order, appConf.colors)}</div>
            </div>
        </div>
        <div className="container">
            <div className="row mt-5">
                <div className="col-12 mt-2">
                    <label className="btn-back link-btn btn-fixed-lb" onClick={props.onClose}
                    ><i className="fa fa-arrow-left" /> {i18n._BTNs.Back}</label>
                </div>
            </div>
        </div>
    </div>
    );
}